import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import styles from './index.module.css'

import ChevronUpIcon from '../../../../shared/components/icons/chevronUp'

const ExpandingFilterPanel = ({
  children,
  id,
  title,
  expanded,
  togglePanel
}) => {
  const onToggle = event => {
    event.preventDefault()
    togglePanel(id)
  }

  const toggleButtonStyle = classNames({
    [styles.buttonToggle]: true,
    [styles.buttonToggleActive]: expanded
  })

  return (
    <div className={styles.filterContainer} data-test-selector={`filter-${id}`}>
      <button
        className={toggleButtonStyle}
        onClick={onToggle}
        type="button"
        aria-label="Click to expand"
      >
        <div className={styles.headingContainer}>
          <h3 className={styles.heading}>{title}</h3>
          <ChevronUpIcon width="13" height="8" />
        </div>
      </button>
      {expanded ? children : null}
    </div>
  )
}

ExpandingFilterPanel.propTypes = {
  children: PropTypes.element.isRequired,
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export default ExpandingFilterPanel
